import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getApprightrolelist = async (roleId: number) => {
    const response = http.get(`/appright/getapprightrolelist?roleId=${roleId}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateAppRight = async (createdBy : string, data: any) => { 
    const response = http.post(`/appright/apprightroleadd?createdBy=${createdBy}`, data)    
    return response;
}
